import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { css } from 'glamor';

import qs from 'qs';

import detectUserMention from 'depop/utils/detectUserMention';

import { ZINDEX_MODAL } from 'depop/styles/zIndex';
import {
  FAMILY_STANDARD,
  FAMILY_EXTENDED_BOLD,
} from 'depop/styles/typography';
import { WHITE, BLACK, RED } from 'depop/styles/colors';

import Logo from 'depop/components/Logo';

import Cross from 'depop/components/icons/Cross';

import Container from '../Container';
import FillHorizontal from '../FillHorizontal';

import { closeSearch } from 'depop/state/navigation';

const KEYCODES = {
  ESCAPE: 27,
};

class SearchOverlay extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      forceFocus: false,
    };
  }

  handleKeyDown = event => {
    if (event.keyCode === KEYCODES.ESCAPE) {
      this.props.closeSearch();
    }
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      document.addEventListener('keydown', this.handleKeyDown);
      this._input.focus();
    }

    if (prevProps.isOpen && !this.props.isOpen) {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }

  setInputRef = el => {
    this._input = el;
  };

  handleSubmit = event => {
    event.preventDefault();
    this._input.blur();

    const query = this._input.value;

    const presentUsername = detectUserMention(query);

    if (presentUsername) {
      this.context.router.push({
        pathname: `/${presentUsername}`,
      });
    } else {
      this.context.router.push({
        pathname: '/search/',
        search: `?${qs.stringify({
          q: query,
        })}`,
      });
    }
  };

  render() {
    const { isOpen, closeSearch, location } = this.props;
    const { forceFocus } = this.state;

    return (
      <div
        {...css({
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          zIndex: ZINDEX_MODAL,
          pointerEvents: 'none',
        })}>
        <div
          {...css({
            position: 'absolute',
            pointerEvents: 'all',
            transform: isOpen ? `translateY(50%)` : null,
            top: '-100%',
            left: 0,
            right: 0,
            height: '100%',
            backgroundColor: WHITE,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            opacity: isOpen ? 1 : 0,
            transition: `transform 0.2s ease-in-out, opacity 0.2s ease-in-out ${isOpen ? '' : '0.2s'}`,
          })}>
          <div {...css({ height: '50%' })} />
          <Container>
            <div>
              <FillHorizontal>
                <div
                  {...css({
                    flexGrow: '0',
                    flexShrink: '0',
                    width: '90px',
                  })}>
                  <Logo />
                </div>
                <FillHorizontal.Spacer size={24} />
                <a
                  {...css({
                    display: 'block',
                    width: 24,
                    height: 24,
                    padding: 4,
                    cursor: 'pointer',
                    ':hover': {
                      color: RED,
                    },
                  })}
                  onClick={closeSearch}>
                  <Cross />
                </a>
              </FillHorizontal>
            </div>
          </Container>
          <div {...css({ flexGrow: 1 })} />
          <Container>
            <form
              {...css({
                marginBottom: 20,
              })}
              action="/search/"
              method="get"
              onSubmit={this.handleSubmit}>
              <input
                {...css({
                  display: 'block',
                  maxWidth: '100%',
                  padding: '3px 0',
                  border: 'none',
                  margin: 0,
                  fontSize: 64,
                  fontFamily: FAMILY_EXTENDED_BOLD,
                  borderBottom: '2px solid #AAAAAA',
                  borderRadius: 0,
                  width: '100%',
                  '::placeholder': {
                    color: '#AAAAAA',
                  },
                  ':focus': {
                    outline: 'none',
                    borderBottomColor: BLACK,
                  },
                })}
                name="q"
                ref={this.setInputRef}
                type="text"
                placeholder="Search"
                autoComplete="off"
                onChange={this.handleChange}
              />
              <div {...css({ height: 8 })} />
              <div
                {...css({
                  color: '#AAAAAA',
                  fontSize: 12,
                  fontFamily: FAMILY_STANDARD,
                })}>
                hit enter to search or escape to close this window
              </div>
            </form>
          </Container>
          <div {...css({ flexGrow: 1 })} />
        </div>
        <div
          {...css({
            position: 'absolute',
            pointerEvents: 'all',
            transform: isOpen ? `translateY(-50%)` : null,
            bottom: '-100%',
            left: 0,
            right: 0,
            height: '100%',
            backgroundColor: RED,
            transition: 'transform 0.2s ease-in-out',
          })}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeSearch: () => dispatch(closeSearch()),
  };
};

const connector = connect(null, mapDispatchToProps);

export default connector(SearchOverlay);



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/SearchOverlay.js